import { dayjs } from '../../support/helpers/dayjs.ts';
import { ISO8601 } from '../../notes/NotesClient.ts';
import { IonInput } from '@ionic/react';
import { FieldInputProps } from './Field.tsx';

export interface DateInputProps extends FieldInputProps {
    value?: ISO8601;
    onChange?: (value?: string) => void;
    max?: ISO8601;
    inISOFormat?: boolean;
}

export const DateInput: React.FC<DateInputProps> = ({ readonly, max = '9999-01-01', inISOFormat, required, value, onChange }) => {

    // NOTE: Avoid dayjs here, because it has a bug where it treats years < 100 as 19xx, but
    // we need to be able to process values as the user is typing, e.g. when entering "2025",
    // the value transitions through 0002 -> 0020 -> 0202 -> 2025.

    const inputType = (readonly && !value ? undefined : 'date');

    const dateValue = value ? value.substring(0, 10) : '';

    const handleChange = (e: any) => {
        if (onChange && !readonly) {
            let date: string | undefined;
            if (e.detail.value) {
                date = e.detail.value;
                if (inISOFormat) {
                    date += 'T00:00:00.000Z';
                }
            }
            onChange(date);
        }
    };

    return (
        <IonInput className="smartlook-show" placeholder="" max={max.substring(0, 10)} value={dateValue} type={inputType} onIonChange={handleChange} readonly={readonly} required={required} />
    );
};
